import {
  PARTNER_AGREEMENT_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';

const mutations = {
  [PARTNER_AGREEMENT_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      if (state[field] !== undefined) {
        state[field] = value;
      }
    });
  },
};

export default mutations;
